import { Component, OnInit, signal } from '@angular/core';
import { FeatureFlagsService } from 'src/app/services/infra/featureFlags/feature-flags.service';
import { FeatureFlagTypes } from 'src/app/models/featureFlag/featureFlagsTypes.enum';

@Component({
  selector: 'app-ai-data-insights-page',
  templateUrl: './ai-data-insights-page.component.html',
  styleUrls: ['./ai-data-insights-page.component.scss'],
})
export class AiDataInsightsPageComponent implements OnInit {
  public isLoading = signal<boolean>(false);
  public isAccountAuthorizedToViewDataInsights = false;

  constructor(private readonly _featureFlagsService: FeatureFlagsService) {}

  ngOnInit(): void {
    this.isAccountAuthorizedToViewDataInsights = this._featureFlagsService.isFeatureEnabled(
      FeatureFlagTypes.AIRuntimeDataInsightsTab
    );
  }
}
